<!--招聘 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
				<div class="search-bar" @click="$router.push('/recruit-search')">
					<img src="../assets/search-icon.png" class="search-icon">
					<input placeholder="请输入搜索关键字" class="search-input" @click="$router.push('/search')" />
				</div>
			</div>
			<ul class="tab-list">
				<li class="active">推荐</li>
				<li>全部</li>
			</ul>
		</div>


		<!-- 推荐 -->
		<!-- <ul class="list">
					<li  @click="$router.push('/recruit-details')">
						<div class="item-top">
							<div class="top-between">
								<span class="font-1">AUTOSAR 工程师</span>
								<span class="font-2">30-50K·15薪</span>
							</div>
							<ul class="tag-list">
								<li>交互设计</li>
								<li>3DMAX</li>
								<li>自动驾驶</li>
							</ul>
							<p class="msg">上海埃恪深科技有限公司 · 上市 · 100人</p>
						</div>
						<div class="item-bottom">
							<div class="item-bottom-left">
								<img src="../assets/avatar.png" class="avarar">
								<span class="user-name">人力资源·郝先生</span>
							</div>
							<div class="item-bottom-right">
								<img src="../assets/icon-58.png" class="location-icon">
								北京市·海淀区
							</div>
						</div>
					</li>
					<div class="normal-box-small">
						<img src="../assets/normal.png">
						暂无数据
					</div>
				</ul> -->

		<!-- 全部 -->
		<div class="wrap2">
			<!-- 左侧侧边栏 -->
			<div class="leftsidebar">
				<ul class="leftsidebar-tab-list">
					<li class="active">
						搞一下
					</li>
					<li>
						架构类
					</li>
					<li>
						软件类
					</li>
					<li>
						硬件类
					</li>
				</ul>
			</div>

			<!-- 右侧侧边栏 -->
			<div class="rightsidebar">
				<ul class="all-list">
					<li @click="$router.push('/recruit-details')">
						<p class="list-title">ECA</p>
						<ul class="sub-list">
							<li>
								<div class="top-between">
									<span class="font-1">AUTOSAR 工程师</span>
									<span class="font-2">30-50K·15薪</span>
								</div>
								<ul class="tag-list">
									<li>交互设计</li>
									<li>3DMAX</li>
									<li>自动驾驶</li>
								</ul>
							</li>
							<button type="button" class="more-btn">
								展开更多
								<img src="../assets/icon-7.png">
							</button>
						</ul>
					</li>
					<!-- 无数据时显示 -->
					<div class="normal-box-small">
						<img src="../assets/normal.png">
						暂无数据
					</div>
				</ul>
			</div>
		</div>

		<div class="float-box" @click="$router.push('/recruit-contact')">
			<img src="../assets/icon-59.png">
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {

			};
		},
		mounted() {

		},
		methods: {

		},
	}
</script>

<style scoped>
	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 84px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		z-index: 499;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.return-img {
		width: 20px;
		margin-right: 10px;
	}

	.search-bar {
		width: calc(100% - 65px);
		height: 36px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 16px;
		margin-right: 10px;
	}

	.search-input {
		flex: 1;
		font-size: 15px;
	}

	.search-input::placeholder {
		color: #B6B6B6;
	}

	.tab-list {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
	}

	.tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		color: #888888;
		position: relative;
	}

	.tab-list>li.active {
		font-size: 18px;
		font-weight: 500;
		color: #222222;
	}

	.tab-list>li.active::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}

	.wrap {
		width: 100%;
		height: calc(var(--vh) * 100 - 84px);
		display: flex;
		flex-direction: column;
		margin: 84px 0 0;
		box-sizing: border-box;
		background-color: #F4F4F4;
		overflow: auto;
	}

	.video-list>li {
		width: calc(50% - 7.5px);
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		margin-bottom: 12px;
		border-radius: 10px;
		box-shadow: 0 1px 16px rgba(0, 0, 0, 0.12);
		overflow: hidden;
	}

	.video-list>li:nth-child(7n + 1) {
		width: 100%;
	}

	.float-box {
		position: fixed;
		right: 15px;
		bottom: 80px;
	}

	.float-box>img {
		width: 64px;
	}

	.wrap2 {
		width: 100%;
		height: calc(100vh - 84px);
		display: flex;
		flex-direction: row;
		box-sizing: border-box;
		background-color: #F4F4F4;
		padding: 0 0 0;
		position: relative;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 12px 15px;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		margin-bottom: 12px;
		padding: 0 10px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.item-top {
		width: 100%;
		padding: 10px 0;
		border-bottom: 1px solid #F2F2F2;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.top-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 7px;
	}

	.font-1 {
		color: #222222;
		font-size: 16px;
		font-weight: bold;
	}

	.font-2 {
		color: #FF3535;
		font-size: 14px;
		font-weight: bold;
	}

	.tag-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.tag-list>li {
		color: #2A63F3;
		font-size: 10px;
		height: 16px;
		line-height: 16px;
		padding: 0 4px;
		margin-bottom: 6px;
		background-color: #F3F3F3;
		margin-right: 6px;
	}

	.msg {
		width: 100%;
		color: #666666;
		font-size: 12px;
		margin-top: 2px;
	}

	.item-bottom {
		width: 100%;
		padding: 10px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.item-bottom-left {
		display: flex;
		align-items: center;
	}

	.avarar {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		margin-right: 6px;
	}

	.user-name {
		font-size: 10px;
		color: #888888;
	}

	.item-bottom-right {
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 10px;
	}

	.location-icon {
		width: 10px;
		margin-right: 6px;
	}

	.normal-box-small {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 120px 0;
	}

	.normal-box-small>img {
		width: 150px;
		margin-bottom: 9px;
	}

	.leftsidebar {
		width: 80px;
		height: 100%;
		overflow-y: auto;
	}

	.leftsidebar-tab-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.leftsidebar-tab-list>li {
		width: 100%;
		text-align: center;
		height: 56px;
		font-size: 14px;
		color: #222222;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.leftsidebar-tab-list>li.active {
		font-weight: 500;
	}

	.leftsidebar-tab-list>li.active::after {
		content: "";
		position: absolute;
		top: 50%;
		left: 0;
		transform: translate(0, -50%);
		background: #2A63F3;
		width: 4px;
		height: 18px;
	}

	.rightsidebar {
		width: calc(100% - 95px);
		height: 100%;
		overflow-y: auto;
	}

	.all-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding-bottom: 10px;
	}

	.all-list>li {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.list-title {
		width: 100%;
		height: 44px;
		line-height: 44px;
		display: flex;
		align-items: center;
		color: #222222;
		font-size: 14px;
		font-weight: bold;
	}

	.sub-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 15px;
		box-sizing: border-box;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
	}

	.sub-list>li {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 12px 0 4px;
		border-bottom: 1px solid #F2F2F2;
		box-sizing: border-box;
	}

	.sub-list>li:last-child {
		margin-bottom: 0;
	}

	.more-btn {
		width: 100%;
		height: 41px;
		line-height: 41px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #2A63F3;
		font-size: 12px;
	}

	.more-btn>img {
		width: 8px;
		margin: 0 0 0 4px;
	}

	.top-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 7px;
	}

	.font-1 {
		color: #222222;
		font-size: 15px;
		font-weight: bold;
	}

	.font-2 {
		color: #FF3535;
		font-size: 12px;
		font-weight: bold;
	}

	.tag-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.tag-list>li {
		color: #2A63F3;
		font-size: 10px;
		height: 16px;
		line-height: 16px;
		padding: 0 4px;
		margin-bottom: 6px;
		background-color: #F3F3F3;
		margin-right: 6px;
		border-radius: 3px;
	}
</style>
